<div class="container--message">
    <section class="container--message__icon">
        <so-icon svg="insert_drive_file" [size]="0.9"/>
    </section>

    <section class="container--message__text">
        <p class="name">{{ name }}</p>
        <p class="size">{{ size }}</p>
    </section>
</div>